"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DatePicker_meta_1 = require("../../DatePicker.meta");
var InjectedStyledComponent_1 = require("../../../../../shared/InjectedStyledComponent");
var rawCssPrefix = "\nborder-collapse: collapse;\nborder-spacing: 0;\ncolor: #333;\nfont-size: 1rem;\nfont-weight: 400;\nline-height: 1.25;\ntext-align: center;\nwidth: 100%;\n";
exports.default = InjectedStyledComponent_1.InjectedStyledComponent('table', DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY, ['table'], rawCssPrefix);
